import {KeypadControlsModule} from '@gongxigames/framework/slot';

export class GameKeypadControlsModule extends KeypadControlsModule {
    protected setupStates(): void {
        super.setupStates();
    }

    protected setupEvents(): void {
        super.setupEvents();
    }

    protected emitTotalBetChanged(): void {
        this.logic.updateSessionBet();
        super.emitTotalBetChanged();
    }
}
